// extracted by mini-css-extract-plugin
export default {"container":"BN-z","dimension":"CN-z","dimensionLabels":"DN-z"};